/* unplugin-vue-components disabled */import { render } from "./index.vue?vue&type=template&id=4a8056ce&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=4a8056ce&scoped=true&lang=css"
import "./index.vue?vue&type=style&index=1&id=4a8056ce&lang=css"
import "./index.vue?vue&type=style&index=2&id=4a8056ce&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a8056ce"]])

export default __exports__